import * as React from 'react';
import * as jwt from 'jwt-simple';

import {getCookie, deleteCookie, setCookie} from "../utils/CookieUtils";

const GlobalContext = React.createContext<GlobalProps>({} as any);
const {Consumer, Provider} = GlobalContext;

const COOKIE_EXPIRATION_TIME = 30;

export {Consumer};

export interface GlobalProps extends State {
  setGlobalState: (state: any) => void,
  storeAuthToken: (authToken: string) => void,
  clearAuthToken: () => void,
}

const DEFAULT_AUTH_USER = {
  id: ''
};

export interface AuthUser {
  id: string,
}

export interface State {
  authToken: string,
  authUser: AuthUser,
  firstname: string,
  _resultadosHolland: string[],
  _resultadosJung: string[]
}

export const AUTH_TOKEN = 'ciclos_jwt';

export class GlobalStore extends React.Component<{ children?: React.ReactNode }, State> {

  public state = {
    authToken: '',
    authUser: DEFAULT_AUTH_USER,
    firstname: '',
    _resultadosHolland: [],
    _resultadosJung: []
  };

  public componentWillMount() {
    const authToken: string = getCookie(AUTH_TOKEN);
    if (authToken) {
      this.storeAuthToken(authToken);
    }
  }

  public render() {
    return (
      <Provider value={{
        ...this.state,
        setGlobalState: this.setGlobalState,
        storeAuthToken: this.storeAuthToken,
        clearAuthToken: this.clearAuthToken,
      }}>
        {this.props.children}
      </Provider>
    )
  }

  private setGlobalState = (state: any) => {
    this.setState(state);
  };

  private storeAuthToken = (authToken: string) => {
    setCookie(AUTH_TOKEN, authToken, COOKIE_EXPIRATION_TIME);
    const decodedAuthToken = jwt.decode(authToken, '', true);
    const authUser = (!!decodedAuthToken && decodedAuthToken.user) || DEFAULT_AUTH_USER;

    this.setState({
      authToken,
      authUser
    })
  };

  private clearAuthToken = () => {
    deleteCookie(AUTH_TOKEN);
    this.setState({
      authToken: '',
      authUser: DEFAULT_AUTH_USER
    });
  };

}

export function connect(Component: any, ...propsList: any[]): any {
  return (props: any) =>
    <Consumer>
      {(globalState: any) => {
        const storeProps = propsList.reduce((agg, curr) => ({...agg, [curr]: globalState[curr]}), {});
        return (
          <Component {...props} {...storeProps} />
        )
      }}
    </Consumer>
}
